import { render, staticRenderFns } from "./TransbankPOSController.vue?vue&type=template&id=4f097058&"
import script from "./TransbankPOSController.vue?vue&type=script&lang=js&"
export * from "./TransbankPOSController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports